<template>
  <header class="main-header">
    <router-link :to="{ name: 'home' }">
      <logo position="header"></logo>
    </router-link>

    <nav class="navbar navbar-static-top">
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <!--<div class="navbar-form navbar-left navbar-search hidden-xs">
        <multiselect
          :options="results"
          :placeholder="$t('general.search')"
          :searchable="true"
          @search-change="asyncFind"
          :loading="searchLoading"
          :showNoOptions="false"
        >
          <span slot="noResult">{{ $t('general.no_result') }}</span>
        </multiselect>
      </div>-->

      <div class="navbar-custom-menu navbar-right">
        <ul class="nav navbar-nav">
          <!--<li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
              <i class="fa fa-bell-o"></i>
              <span class="label label-danger" v-show="unreadNotificationsCount !== 0" v-text="unreadNotificationsCount"
                    id="notification-counter"></span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">{{ $tc('header.notification.count', unreadNotificationsCount) }}</li>
              <li>
                <ul class="menu">
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-aqua"></i> 5 new members joined today
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-warning text-yellow"></i> Very long description here that may not fit into the
                      page and may cause design problems
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-red"></i> 5 new members joined
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-shopping-cart text-green"></i> 25 sales made
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-user text-red"></i> You changed your username
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="#">View all</a></li>
            </ul>
          </li>-->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <span class="initial" v-show="currentUser.initial !== ''">{{ currentUser.initial }}</span>
              <span class="hidden-xs">{{ currentUser.name }}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="user-footer">
                <!--<div class="pull-left">
                  <va-button
                    :name="$t('general.parameters')"
                    :isFlat="true"
                    @click.native="$router.push({ name: 'parameters' })"
                  ></va-button>
                </div>-->
                <!--<div class="pull-right">-->
                <div>
                  <va-button
                    :name="$t('general.logout')"
                    :isFlat="true"
                    @click.native="logout({ noRedirect: false, query: { law_firm_id: lawFirmSelected }})"
                  ></va-button>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!--<div class="navbar-form navbar-right navbar-select hidden-xs" v-show="displayLawFirmSelection">
        <multiselect
          v-model="lawFirmSelection"
          :options="lawFirmsSelectOptions"
          track-by="id"
          label="name"
          :searchable="false"
          :allowEmpty="false"
          select-label=""
          :selectedLabel="$t('general.selected')"
          :deselectLabel="$t('general.selected')">
        </multiselect>
      </div>-->
    </nav>
  </header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// noinspection NpmUsedModulesInstalled
import VAButton from 'va/components/VAButton.vue'
import Logo from './components/common/Logo.vue'

export default {
  data () {
    return {
      search: '',
      results: [],
      searchLoading: false
    }
  },
  computed: {
    ...mapState('lawFirms', {
      lawFirmSelected: 'selected'
    }),
    ...mapGetters([
      'currentUser',
      'unreadNotificationsCount'
    ]),
    ...mapGetters('lawFirms', {
      lawFirmsSelectOptions: 'selectOptions'
    }),
    displayLawFirmSelection () {
      return this.lawFirmsSelectOptions.length > 1
    },
    lawFirmSelection: {
      get () {
        return this.lawFirmsSelectOptions.find(option => option.id === this.lawFirmSelected)
      },
      set (value) {
        this.updateSelectedLawFirm(value.id)
      }
    }
  },
  methods: {
    ...mapActions('lawFirms', [
      'updateSelectedLawFirm'
    ]),
    ...mapActions('user', [
      'logout'
    ]),
    asyncFind (query) {
      console.log('Recherche : ' + query)
    }
  },
  components: {
    Logo,
    'va-button': VAButton
  }
}
</script>

<style lang="scss">
  .main-header {
    /*noinspection CssUnusedSymbol*/
    .multiselect {
      line-height: 1 !important;
    }

    .navbar-search {
      width: 25%;
      padding: 0 0 0 15px;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .navbar-select {
      width: 15%;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .navbar-custom-menu {
      margin-right: 0;
    }

    .initial {
      background-color: rgb(55, 79, 100);
      border-radius: 50%;
      color: #fff;
      display: inline-block;
      font-size: 1.3rem;
      font-weight: 300;
      height: 25px;
      line-height: 25px;
      text-align: center;
      vertical-align: middle;
      width: 25px;
      float: left;
      margin: -2px 5px 0 0;
    }
  }
</style>
